import { optionsFactoryKeys } from './config';

class OptionNode {
  constructor(groupData, sortStrategy) {
    this._groupData = groupData;
    this._sortStrategy = sortStrategy;
  }

  add({ key, value }) {
    throw new Error('Метод add должен быть реализован');
  }

  has(key) {
    throw new Error('Метод has должен быть реализован');
  }

  normalize() {
    throw new Error('Метод normolize должен быть реализован');
  }

  getOrCreate(key, createFn) {
    if (this.isComposite()) {
      throw new Error(
        'Метод normolize должен быть реализован, так как данный экземпляр класса не является конечным'
      );
    }
  }

  isComposite() {
    return false;
  }

  _getGroupData() {
    return Boolean(this._groupData) ? { ...this._groupData } : {};
  }

  _getSortedChildren(children) {
    return typeof this._sortStrategy === 'function'
      ? children.slice().sort(this._sortStrategy)
      : children;
  }
}

class OptionsComposite extends OptionNode {
  constructor(groupData, sortStrategy) {
    super(groupData, sortStrategy);
    this._children = new Map();
  }

  add({ key, value }) {
    this._children.set(key, value);
  }

  getOrCreate(key, createFn) {
    if (!this.has(key) && typeof createFn === 'function') {
      this._children.set(key, createFn());
    }

    return this._children.get(key);
  }

  has(key) {
    return this._children.has(key);
  }

  isComposite() {
    return true;
  }

  normalize() {
    const result = super._getGroupData();

    const children = [...this._children.values()].flatMap((el) =>
      typeof el.normalize === 'function' ? el.normalize() : el
    );

    result.children = this._getSortedChildren(children);

    return result;
  }
}

class OptionLeaf extends OptionNode {
  constructor(groupData, sortStrategy) {
    super(groupData, sortStrategy);
    this._children = new Set();
  }

  add({ value }) {
    this._children.add(value);
  }

  has(value) {
    return this._children.has(value);
  }

  normalize() {
    const result = super._getGroupData();
    result.children = this._getSortedChildren([...this._children]);
    return result;
  }
}

const optionsCompositeFactory = (groupData, sortStrategy) =>
  new OptionsComposite(groupData, sortStrategy);
const optionLeafFactory = (groupData, sortStrategy) =>
  new OptionLeaf(groupData, sortStrategy);

export const createOptionNode = ({ type, groupData, sortStrategy }) => {
  switch (type) {
    case optionsFactoryKeys.composite:
      return optionsCompositeFactory(groupData, sortStrategy);

    case optionsFactoryKeys.leaf:
      return optionLeafFactory(groupData, sortStrategy);

    default:
      throw new Error(`Необрабаываемый тип в создании опций - ${type}`);
  }
};
